// extracted by mini-css-extract-plugin
export var wordContainer = "_jp-0";